import { Link } from "react-router-dom";
import { COMPANY } from "@/data/company";

export const Logo = ({ className = "h-9", withText = true }) => (
  <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo" aria-label="Ronalp Enseigne - accueil">
    <img
      src={COMPANY.logo}
      alt="Logo Ronalp Enseigne"
      className={className + " w-auto select-none"}
      width="160"
      height="48"
    />
  </Link>
);
